<!--
  tips: 当前组件配合项目使用,在项目加载完成时允许用户操作
-->
<script>
  export default {
    name: "index",
    props: {
      tag: {
        type: String,
        default: 'div'
      }
    },
    render(createElement) {
      const listeners = this.$listeners;
      Object.keys(listeners).forEach(name => {
        listeners[name] = event => {
          if (window.vm_screen_loading) return;
          this.$emit(name, event, ...arguments);
        };
      });
      return createElement(this.tag, {
        on: listeners
      }, this.$slots.default);
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/event/index.vue